import { storyProps } from 'virtual:tidal-sandbox-list'
import type { RequestHandler } from 'msw'
import type { ReactElement } from 'react'
import type { SandboxStory, SandboxStoryDefault, StoryDecorator, StoryDecoratorProps } from '../../exports.js'
import { Msw } from './Msw.js'

type ImportedModule = Record<string, SandboxStory> & {
  default?: SandboxStoryDefault
}

export function composeEnhancers(module: ImportedModule, storyName: string) {
  let decorators: StoryDecorator[] = []
  const storyDecoratorProps: StoryDecoratorProps = {}

  // -----------------------------------------
  // ------------------ MSW

  let mswHandlers: RequestHandler[] = []

  if (module.default?.msw) {
    mswHandlers = module.default.msw
  }

  if (module[storyName]?.msw) {
    mswHandlers = module[storyName].msw
  }

  // -----------------------------------------
  // ------------------ Component's props

  const ComponentStory = module[storyName] as SandboxStory
  const componentStoryProps = {
    ...storyProps,
    ...(module.default?.storyProps ? module.default.storyProps : {}),
    ...(module[storyName]?.storyProps ? module[storyName].storyProps : {}),
  }

  // -----------------------------------------
  // ------------------ Decorators

  if (module[storyName] && Array.isArray(module[storyName].decorators)) {
    decorators = [...decorators, ...module[storyName].decorators]
  }
  if (module.default && Array.isArray(module.default.decorators)) {
    decorators = [...decorators, ...module.default.decorators]
  }

  // -----------------------------------------
  // ------------------ Story Decorator Props

  Object.assign(storyDecoratorProps, module.default?.decoratorsProps, module[storyName]?.decoratorsProps)

  // console.log({ storyName, decorators, parameters, props })

  // -----------------------------------------
  // ------------------ returned component

  return function RenderDecoratedStory() {
    return decorators.reduceRight<ReactElement>(
      (component, Decorator, idx) => {
        // keep the `key` prop outside the JSX to avoid Biome warnings
        const key = `StoryDecorators_${idx}`

        return (
          <Decorator key={key} parameters={storyDecoratorProps}>
            {component}
          </Decorator>
        )
      },
      <Msw key="MswMaybeWrappedStory" mswHandlers={mswHandlers}>
        <ComponentStory {...componentStoryProps} />
      </Msw>,
    )
  }
}
